module.exports = __webpack_public_path__ + "static/media/connector-downwards.853a1876.svg";